import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { MenuItem, Message } from 'primeng/api';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-manage-foreclosure-auction',
  templateUrl: './manage-foreclosure-auction.component.html',
  styleUrls: ['./manage-foreclosure-auction.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [MessageService]
})
export class ManageForeclosureAuctionComponent implements OnInit, OnDestroy {
  messages: Message[] = [];
  crumbs: MenuItem[];
  action = { 'addForeclosureAuction': false, 'editForeclosureAuction': false, 'listForeclosureAuction': true };
  selectedForeclosureAuction: {};
  display: boolean;

  constructor(private messageService: MessageService) { }

  ngOnInit() {
    localStorage.clear();
    this.setBreadCrumbs([{ label: 'Manage Foreclosure Auction Location ', disabled: true }]);
  }

  displayAddForeclosureAuctionForm(): void {
    this.action = { 'addForeclosureAuction': true, 'editForeclosureAuction': false, 'listForeclosureAuction': false };
    this.setBreadCrumbs([{ label: 'Manage Foreclosure Auction Location' }, { label: 'Add Foreclosure Auction Location', disabled: true }]);
  }

  hideAddForeclosureAuctionForm(display): void {
    this.action = { 'addForeclosureAuction': false, 'editForeclosureAuction': false, 'listForeclosureAuction': true };
    this.setBreadCrumbs([{ label: 'Manage Foreclosure Auction Location' }]);
  }  

  displayEditForeclosureAuctionForm() : void {
    this.action = { 'addForeclosureAuction': false, 'editForeclosureAuction': true, 'listForeclosureAuction': false};
    this.setBreadCrumbs([{ label: 'Manage Foreclosure Auction Location' }, { label: 'Edit Foreclosure Auction Instruction', disabled: true }]);
  }

  hideEditForeclosureAuctionForm(display): void {
    this.action = { 'addForeclosureAuction': false, 'editForeclosureAuction': false, 'listForeclosureAuction': true };
    this.setBreadCrumbs([{ label: 'Manage Foreclosure Auction Location' }]);
  }  

  closeDialog(data){
    this.display =  false;
  }

  setBreadCrumbs(elements: any[]): void {
    this.crumbs = elements;
  }

  setSelectedForeclosureAuction(data : any) : void {
    this.selectedForeclosureAuction = data;
   }
 
  showMessage(element: any): void {
    this.messageService.clear();
    this.messageService.add({severity: element.severity, detail: element.detail});
  }

  showChangeLogDialog() {
    this.display = true;
   }
  ngOnDestroy() {
    localStorage.clear();
  }

}
